import React from 'react';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-fetching-library';
import { Typography, Collapse, Stack, Button, Box, CircularProgress } from '@mui/material';
import { getLatestFormAction, getClientDataAction } from '../../../services/request';
import { FormPanel } from '../../../components/form/FormPanel';
import LoginOrRegister from './LoginOrRegister';
import { useAuthenticated, useResponsive } from '../../../services/hooks';
import SelectParticipant from './SelectParticipant';
import { Header } from '../../../components/landing/Header';

const GiewartowFormPage = ({ formIdentifier, boskieWakacje, seasonYear = 2027 }) => {
  const { isAuthenticated } = useAuthenticated();
  const params = useParams();
  const { loading, payload, error } = useQuery(getLatestFormAction(formIdentifier, seasonYear));
  const { loading: clientLoading, payload: clientPayload, error: clientError } = useQuery(getClientDataAction());
  const [form, setForm] = React.useState(null);
  const [clientData, setClientData] = React.useState({});
  const [participantData, setParticipantData] = React.useState({});
  const [isHiddenSelectParticipant, setIsHiddenSelectParticipant] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const isDesktop = useResponsive('up', 'lg');
  const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';

  const handleExpandClick = () => {
    setExpanded(true);
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setForm(payload);
    }

    if (!clientError && !clientLoading) {
      if (!_.isNil(clientPayload.name)) {
        const lastIndex = clientPayload.name.lastIndexOf(' ');
        const name = clientPayload.name.substr(0, lastIndex);
        const surname = clientPayload.name.substr(lastIndex + 1);
        const client = { ...clientPayload, name, surname };
        setClientData(client);
      } else {
        setClientData(clientPayload);
      }

    }

  }, [loading, clientLoading]);

  // --- Google Tag Manager ---
  React.useEffect(() => {
    if (!isProduction) {
      return;
    }
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== 'dataLayer' ? `&l=${l}` : '';
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    }(window, document, 'script', 'dataLayer', 'GTM-WMZRNJJ3'));

    // noscript fallback
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WMZRNJJ3';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  // --- END Google Tag Manager ---

  if (error) {
    return <Typography>Nie udało się załadować formularza</Typography>;
  }

  if (isAuthenticated()) {
    return (
      <>
        <Header isDesktop={isDesktop} redirectUrl="https://sun-sport.pl/" />
        <LoginOrRegister />
        {!_.isEmpty(clientData) && !_.isEmpty(clientData.participants) && !isHiddenSelectParticipant ? <SelectParticipant participants={clientData.participants} setParticipantData={setParticipantData}/> : null}
        {form != null && <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
          <FormPanel form={form} clientData={clientData} participantData={participantData} setIsHiddenSelectParticipant={setIsHiddenSelectParticipant} boskieWakacje={boskieWakacje} />
        </div>}
      </>
    );
  }

  return (
    <div>
      <Header isDesktop={isDesktop} redirectUrl="https://sun-sport.pl/" />
      <Stack spacing={2} direction={isDesktop ? 'column' : 'column-reverse'}>
        <LoginOrRegister />
        {form != null
          ? <div>
            <Stack direction="column" justifyContent="space-around" alignItems="center" m={2}>
              <Typography sx={{ width: isDesktop ? '30%' : '100%' }} align="center" mb={2}>Używamy zabezpieczonego połączenia SSL, które szyfruje dane przesyłane między użytkownikiem, a serwerem. Dzięki certyfikatowi SSL macie Państwo pewność, że przekazane dane są bezpieczne.</Typography>
              <Button
                variant="contained"
                onClick={handleExpandClick}
                disabled={expanded}
                style={{ textTransform: 'none', minWidth: 320 }}
              >
                  Wypełnij formularz jako gość, bez konieczności rejestracji
              </Button>
              <Box height={50} />
              {/* {isProduction && <Stack
                spacing={2}
                sx={{
                  width: isDesktop ? '30%' : '100%',
                  color: 'primary.main'
                }}
              >
                <Typography variant="h5" fontWeight={700} align="center">
                  DRODZY RODZICE
                </Typography>

                <Stack component="ul" spacing={1} sx={{ m: 0, pl: 3 }}>
                  <Typography component="li" fontWeight={600}>
                    rezerwacji na turnus 7 (16-23.08) można dokonywać wyłącznie do piątku 14 sierpnia godz. 10.00,
                    przy czym formalności będzie należało dopełnić maksymalne do godziny 12.00
                  </Typography>

                  <Typography component="li" fontWeight={600}>
                    rezerwacji na turnus 8 (23-30.08) można dokonywać wyłącznie do piątku 21 sierpnia godz. 10.00,
                    przy czym formalności będzie należało dopełnić maksymalne do godziny 12.00
                  </Typography>
                </Stack>
              </Stack>} */}
            </Stack>

            {expanded && <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
              <FormPanel form={form} clientData={clientData} boskieWakacje={boskieWakacje} />
            </div>}
          </div>
          : <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '300px',
              flexDirection: 'column'
            }}
          >
            <CircularProgress size={160} />
            <Typography variant="h6" mt={4}>Wczytujemy dane...</Typography>
          </Box>}
      </Stack>
    </div>
  );
};

export default GiewartowFormPage;
